// extracted by mini-css-extract-plugin
module.exports = {"button":"WalletsPage_button__zoFRi","selected":"WalletsPage_selected__Kqu9g","qrWrapper":"WalletsPage_qrWrapper__QYWsA"};